"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTitleRegion = void 0;
const getRestTitle = (name, idx, branch, area) => {
    let title = "";
    if (idx || idx === 0) {
        title += `${idx + 1}. `;
    }
    title += `${name} `;
    title += (0, exports.getTitleRegion)(branch, area);
    return title;
};
const getTitleRegion = (branch, area) => {
    let title = "";
    if (branch) {
        title += "+" + branch;
    }
    else {
        if (area && Array.isArray(area)) {
            title += "+" + area[0];
        }
    }
    return title;
};
exports.getTitleRegion = getTitleRegion;
exports.default = getRestTitle;
